import { render } from "./OidoModalSubtitle.vue?vue&type=template&id=ad23c7bc&scoped=true"
import script from "./OidoModalSubtitle.vue?vue&type=script&lang=js"
export * from "./OidoModalSubtitle.vue?vue&type=script&lang=js"

import "./OidoModalSubtitle.vue?vue&type=style&index=0&id=ad23c7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad23c7bc"]])

export default __exports__